import {
  downloadContentFromIasCognito,
  downloadIasFileCognito,
  getStorageInfoCognito,
} from '../components/jobui/utils/functions'

export const DownloadUtil = {
  /**
   * Download a file from Storage module, given its ias ID.
   *
   * The file will be download the to Download directory, and will appear
   * in the list of downloaded files of the browser.
   *
   * @param iasId The ias ID, without `ias://` scheme.
   */
  downloadFileWithCognito: async ({ iasId }: { iasId: string }) => {
    const { data } = await getStorageInfoCognito(iasId)
    if (data?.filename !== undefined) {
      await downloadIasFileCognito(iasId, data?.filename)
    }
  },

  /**
   * Download and returns the contents of a file from Storage module,
   * given its ias ID.
   *
   * @param iasId The ias ID, without `ias://` scheme.
   * @returns A blob or null
   */
  getStorageDataWithCognito: async ({ iasId }: { iasId: string }) => {
    const { data } = await getStorageInfoCognito(iasId)
    if (data?.filename !== undefined) {
      return downloadContentFromIasCognito(iasId, data?.filename)
    }

    return null
  },

  /**
   * Download the contents of a report and write to a local JSON file.
   *
   * @param fileName The name of the file without extension to write.
   * @param report The JSON contents to write into the local file.
   */
  downloadJSON: ({ fileName, report }: { fileName?: string; report: any }) => {
    const jsonStr = JSON.stringify(report)
    const blob = new Blob([jsonStr], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `${fileName}.json`
    document.body.appendChild(link)
    link.click()
    try {
      document.body.removeChild(link)
    } catch (e) {
      console.log('Error in downloadJSON', e)
    }
    URL.revokeObjectURL(url)
  },
}
